var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Overlay',{attrs:{"show":_vm.visible,"lock-scroll":false}},[_c('div',{staticClass:"sign-view"},[(_vm.visible)?_c('Sign',{on:{"exportImg":_vm.exportImg,"quit":_vm.close}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }